import { useState, useEffect } from "react";
import { atualizarReservaPeriodoService } from "../services/atualizarReservaPeriodoService";

export const useAtualizarReservaPeriodo = () => {
  const [reservaPeriodoAtualizado, setReservaPeriodoAtualizado] = useState<
    boolean | null
  >(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const resetError = () => setError(null);

  const atualizar = async (
    reservaId: number | null,
    periodoUsuarioId: number | null | undefined
  ) => {
    setIsLoading(true);
    if (reservaId !== null && periodoUsuarioId !== null) {
      try {
        const data = await atualizarReservaPeriodoService(
          reservaId,
          periodoUsuarioId
        );
        if (data) {
          setSuccess("Período Vinculado com sucesso");
        } else {
          setError("Não foi possível vincular período");
        }
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    }
  };

  // useEffect(() => {
  //   const fetchReservas = async () => {
  //     if (reservaId !== null && periodoUsuarioId !== null) {
  //       try {
  //         const data = await atualizarReservaPeriodoService(
  //           reservaId,
  //           periodoUsuarioId
  //         );
  //         setReservaPeriodoAtualizado(data); // Supondo que data será true/false
  //       } catch (error) {
  //         console.error(error);
  //       } finally {
  //         setIsLoading(false);
  //       }
  //     }
  //   };

  //   fetchReservas();
  // }, [reservaId, periodoUsuarioId]);

  return { atualizar, success, error, resetError, isLoading };
};
